module.exports = __webpack_public_path__ + "static/joelle-fd87b503850d9825820213835f02b13c.png";